<template>
  <article class="view">
    <header class="view__header" v-if="header">
      <VText center>{{ header }}</VText>

      <router-link class="view__back"
        v-if="backButtonTo"
        :to="backButtonTo"
      ></router-link>
    </header>

    <main class="view__content">
      <VSlider :currentSlideIndex="currentSlideIndex"
        :disabled="!hasSlides"
      >
        <slot />
      </VSlider>

      <VText center class="view__page" v-if="hasSlides">
        Strona {{ currentSlideIndex + 1 }}/{{ totalSlides }}
      </VText>

      <VButtonGroup v-if="hasSlides" class="view__pager">
        <VButton special @click="changeSlide(-1)" v-if="!isOnFirstSlide">Wstecz</VButton> 
        <VButton special @click="changeSlide(1)" v-if="!isOnLastSlide">Dalej</VButton> 
      </VButtonGroup>
    </main>
  </article>
</template>

<script>
import VText from '@/components/VText.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';
import VSlider from '@/components/VSlider.vue';

export default {
  name: 'VView',
  components: {
    VText,
    VButton,
    VButtonGroup,
    VSlider,
  },

  props: {
    backButtonTo: {
      type: String,
    },

    header: {
      type: String,
    },

    isSlider: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    currentSlideIndex: 0,
  }),

  computed: {
    totalSlides() {
      return this.isSlider ? this.$slots.default.length : 1;
    },

    hasSlides() {
      return this.totalSlides > 1;
    },

    isOnFirstSlide() {
      return this.currentSlideIndex <= 0;
    },

    isOnLastSlide() {
      return this.currentSlideIndex >= this.totalSlides - 1;
    },
  },

  methods: {
    changeSlide(indexDifference) {
      const newSlideIndex = this.currentSlideIndex + indexDifference;

      this.currentSlideIndex = Math.max(0, Math.min(newSlideIndex, this.totalSlides - 1));

      this.$emit('slide-change', this.currentSlideIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  padding: 50px 0 50px;

  &__header {
    position: relative;
    padding: 10px;

    background-color: #ffffff;

    box-shadow: 7.6px 10.5px 9px 0 rgba(0, 0, 0, 0.35);

    ::v-deep .text {
      font-size: font(30px, 50px);
      line-height: 1.25em;
      text-transform: uppercase;
    }
  }

  &__back {
    position: absolute;
    top: 50%;
    left: 10px;
    width: 60px;
    height: 60px;

    background-image: url('~@/assets/view-back.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;

    transform: translateY(-50%);

    &:hover {
      transform: translateY(-50%) scale(1.1);
    }

    @media screen and (max-width: 900px) {
      width: 30px;
      height: 30px;
    }
  }

  &__content {
    padding: 50px;
    min-height: 300px;

    @media screen and (max-width: 800px) {
      padding: 50px 20px;
    }
  }

  &__page {
    text-transform: uppercase;
    font-size: 16px;
    line-height: 1.25em;
  }

  &__pager {
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:not(:first-child) {
      margin-top: 30px;
    }

    ::v-deep .button {
      max-width: 300px;
      min-height: 100px;
      margin: 0 10px;

      &__content {
        min-height: 100px;
      }

      &:not(:first-child) {
        margin-top: 0;
      }
    }
  }
}
</style>
